import { api } from '@/lib/api'
import type { FormSchema } from '../types'
import type {
  Annex,
  AnnexListResponse,
  AnnexableFieldsResponse,
  PatchAnnexRequest,
  PublishAnnexRequest,
} from './types'

const base = (contractId: number) => `/api/contracts/${contractId}/annexes`

export async function listAnnexes(contractId: number, includeCancelled = false): Promise<Annex[]> {
  const r = await api.get<AnnexListResponse>(base(contractId), { params: { includeCancelled } })
  return r.data.items
}

export async function getAnnex(contractId: number, annexId: number): Promise<Annex> {
  const r = await api.get<Annex>(`${base(contractId)}/${annexId}`)
  return r.data
}

export async function createAnnexDraft(contractId: number): Promise<Annex> {
  const r = await api.post<Annex>(base(contractId), {})
  return r.data
}

export async function patchAnnexDraft(
  contractId: number,
  annexId: number,
  payload: PatchAnnexRequest,
): Promise<Annex> {
  const r = await api.patch<Annex>(`${base(contractId)}/${annexId}`, payload)
  return r.data
}

export async function publishAnnex(
  contractId: number,
  annexId: number,
  payload: PublishAnnexRequest,
): Promise<Annex> {
  const r = await api.post<Annex>(`${base(contractId)}/${annexId}/publish`, payload)
  return r.data
}

export async function cancelAnnexDraft(
  contractId: number,
  annexId: number,
  expectedVersion: number,
): Promise<void> {
  await api.delete(`${base(contractId)}/${annexId}`, { params: { expectedVersion } })
}

export async function getAnnexableFields(contractId: number): Promise<AnnexableFieldsResponse> {
  const r = await api.get<AnnexableFieldsResponse>(`${base(contractId)}/annexable-fields`)
  return r.data
}

export async function getAnnexParametersSchema(contractId: number): Promise<FormSchema> {
  const r = await api.get<FormSchema>(`${base(contractId)}/parameters-schema`)
  return r.data
}
